export const sstPreviewUrl = (
  defaultValue: string,
  app: "access" | "trivia" | "web" | "the-word" | "payments" | "tool" = "web",
) => {
  if (!process.env.SST_STAGE && !process.env.SST_RESOURCE_App)
    return defaultValue ?? "";

  let stage = process.env.SST_STAGE;
  if (!stage) {
    try {
      const json = JSON.parse(process.env.SST_RESOURCE_App);
      stage = json.stage;
    } catch (e) {
      return defaultValue ?? "";
    }
  }

  if (/pr\d+/.test(stage)) {
    switch (app) {
      case "access":
        return `https://${stage}-access-preview.hallow.com`;
      case "trivia":
        return `https://${stage}-trivia-preview.hallow.com`;
      case "the-word":
        return `https://${stage}-theword-preview.hallow.com`;
      case "payments":
        return `https://${stage}-payments-preview.hallow.com`;
      case "tool":
        return `https://${stage}-tool-v2-preview.hallow.com`;
      case "web":
      default:
        return `https://${stage}-preview.hallow.com`;
    }
  }
  if (stage === "rc") {
    switch (app) {
      case "access":
        return "https://access-rc.hallow.com";
      case "trivia":
        return "https://trivia-rc.hallow.com";
      case "the-word":
        return "https://theword-rc.hallow.com";
      case "payments":
        return "https://payments-rc.hallow.com";
      case "tool":
        return "https://tool-vite-rc.hallow.com";
      case "web":
      default:
        return "https://rc.hallow.com";
    }
  }
  return defaultValue ?? "";
};
